export default {
  updateSurveyListingStatus: {
    url: '/survey_listings/:id/update_status/',
    options: {
      method: 'POST',
    },
  },
  updateSurveyListingStatuses: {
    url: '/survey_listings/update_statuses/',
    options: {
      method: 'POST',
    },
  },
};
